import styled from "styled-components";
import { Swiper } from "swiper/react/swiper-react";

export const CustomSwiper = styled(Swiper)`
  border-radius: 8px;
  .swiper-pagination {
    width: auto;
    display: flex;
    flex-direction: column;
    right: 10px;
    left: auto;
    bottom: 50%;
    transform: translate(0, 50%);
    row-gap: 5px;
  }
  .swiper-pagination-bullet {
    height: 15px;
    width: 15px;
    border: 1px solid #fff;
    background: transparent;
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    background: #fff;
  }
  .swiper-wrapper {
    height: 500px;
    img {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }
  @media (max-width: 992px) {
    border-radius: 0px;
  }
  @media (max-width: 770px) {
    .swiper-wrapper {
      height: 400px;
    }
  }
`;
